import React, { useEffect, useState } from 'react';

interface Props {
  title?: string;
  subtitle?: string;
  currentOption: string;
  placeHolder?: string;
  setCurrentOption: (_option: string) => void;
  options: { value: string; text: string }[] | string[];
  disabled?: boolean;
  isOptionDisabled?: (_option: string) => boolean;
  isEditable?: boolean;
  showNoneOption?: boolean;
}

export const OptionSelect: React.FC<Props> = ({
  currentOption,
  options,
  setCurrentOption,
  subtitle = '',
  title,
  placeHolder = 'Select',
  disabled = false,
  isOptionDisabled,
  isEditable = true,
  showNoneOption = true,
}) => {
  const [hasSelectedValue, setHasSelectedValue] = useState(false);

  useEffect(() => {
    currentOption && setHasSelectedValue(true);
  }, [currentOption]);

  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setCurrentOption(event.target.value);
  };

  return (
    <div>
      <div className="flex flex-col ">
        {title && <p className="text-lg text-black mb-1">{title}</p>}
        {subtitle && <p className="text-sm text-gray-600 mb-1">{subtitle}</p>}
        {isEditable ? (
          <div className="w-full">
            <select
              disabled={disabled}
              value={currentOption || ''}
              title={title}
              className={`select text-base bg-white rounded outline-gray-450 focus:outline-blue-600 p-[5px] w-full ${
                !hasSelectedValue && 'text-gray-400'
              }`}
              onChange={(e) => handleSelectChange(e)}
            >
              <option value="" disabled hidden>
                {placeHolder}
              </option>
              {showNoneOption && <option value="">None</option>}
              {Array.isArray(options) &&
                options.map((option, idx) => {
                  const value = typeof option === 'string' ? option : option.value;
                  const text = typeof option === 'string' ? option : option.text;
                  return (
                    <option
                      key={idx}
                      value={value}
                      disabled={isOptionDisabled?.(value)}
                      className={isOptionDisabled?.(value) ? 'text-gray-300' : 'text-black'}
                    >
                      {text}
                    </option>
                  );
                })}
            </select>
          </div>
        ) : (
          <p>{currentOption}</p>
        )}
      </div>
    </div>
  );
};
